import { config } from '../config';

const errorMessage = '[apiSubscription] error to method';

export const apiSubscription = {
  activeSub: async (axiosPrivate) => {
    try {
      const response = await axiosPrivate.get(config.API.SUBSCRIPTION.ACTIVE);
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'activeSub', error);
      throw error;
    }
  },
  history: async (axiosPrivate) => {
    try {
      const response = await axiosPrivate.get(config.API.SUBSCRIPTION.HISTORY);
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'history', error);
      throw error;
    }
  },
  resume: async (axiosPrivate) => {
    try {
      const response = await axiosPrivate.post(config.API.SUBSCRIPTION.RESUME);
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'resume', error);
      throw error;
    }
  },
  cancel: async (axiosPrivate) => {
    try {
      const response = await axiosPrivate.post(config.API.SUBSCRIPTION.CANCEL);
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'cancel', error);
      throw error;
    }
  }
};
